import {
  Flex,
  Box,
  IconButton,
  useDisclosure,
  Stack,
  Collapse,
  Text,
  Button,
  Link,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
} from "@chakra-ui/react";

import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";

import { logout } from "../../redux/reducers/authReducer";

import { useDispatch, useSelector } from "react-redux";

import { useNavigate, useLocation } from "react-router-dom";

import { FaChevronDown } from "react-icons/fa";

import Cookie from "js-cookie";

import toast from "react-hot-toast";

const Navbar = () => {
  const token = Cookie.get("token");

  const { isOpen, onToggle } = useDisclosure();

  const navigate = useNavigate();
  const location = useLocation();

  const customerId = localStorage.getItem("customerId");

  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());

    toast.success("Logout Successfully");

    navigate("/");

    window.location.reload();
  };

  // Check active route
  const isActive = (path) => {
    return location.pathname === path;
  };

  const getMenuItemStyle = (path) => {
    return isActive(path)
      ? {
          borderBottom: "1px solid white",
          color: "white",
        }
      : {};
  };

  // Common button style
  const menuButtonStyle = {
    mt: 2,
    as: Button,
    size: "sm",
    bg: "white",
    color: "#0F3D2E",
    borderRadius: "md",
    px: 4,
    boxShadow: "0 3px 5px rgba(247, 148, 29, 0.45)",
    _hover: {
      bg: "white",
      color: "#0F3D2E",
      transform: "translateY(-1px)",
      boxShadow: "0 2px 5px rgba(247, 148, 29, 0.55)",
    },
    _active: {
      bg: "white",
      transform: "scale(0.97)",
    },
    transition: "all 0.2s",
    rightIcon: <FaChevronDown />,
  };

  return (
    <Flex
      align="center"
      justify="space-between"
      background="#0F3D2E"
      padding={{ base: "0.5rem 1rem", md: "1rem 2rem" }}
      borderBottom="1px"
      borderColor="gray.200"
      fontSize="13px"
      flexWrap="wrap"
    >
      {/* LOGO */}
      <Box cursor="pointer" onClick={() => navigate("/")}>
        <Text
          fontSize="xl"
          fontWeight="bold"
          color="white"
          fontFamily="cursive"
          fontStyle="italic"
          transform="rotate(-2deg)"
          borderBottom="2px solid #F7941D"
          display="inline-block"
          pb="2px"
        >
          Rasoi
          <Box as="span" color="#F7941D">
            Bills
          </Box>
        </Text>
      </Box>

      {/* MOBILE MENU BUTTON */}
      <Box display={{ base: "block", lg: "none" }}>
        <IconButton
          onClick={onToggle}
          icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
          variant="ghost"
          aria-label="Toggle navigation"
          color="white"
          _hover={{
            bg: "whiteAlpha.200",
          }}
        />
      </Box>

      {/* DESKTOP NAVIGATION */}
      <Box
        display={{ base: "none", lg: "block" }}
        alignItems="center"
      >
        <Stack spacing={3} direction="row" align="center">
          {customerId ? (
            <>
              {/* ===================================================== */}
              {/* OFF SHOP */}
              {/* ===================================================== */}

              <Menu>
                <MenuButton {...menuButtonStyle}>
                  <Text fontSize="sm" fontWeight="700">
                    🔴 Off Shop
                  </Text>
                </MenuButton>

                <MenuList zIndex={9999}>
                  <MenuItem
                    onClick={() => navigate("/off-shop")}
                  >
                    Off Shop
                  </MenuItem>
                </MenuList>
              </Menu>

              {/* ===================================================== */}
              {/* EXPENSES */}
              {/* ===================================================== */}

              <Menu>
                <MenuButton {...menuButtonStyle}>
                  <Text fontSize="sm" fontWeight="700">
                    Expenses
                  </Text>
                </MenuButton>

                <MenuList zIndex={9999}>
                  <MenuItem
                    onClick={() => navigate("/all-expense")}
                  >
                    All Expenses
                  </MenuItem>

                  {/*
                  <MenuItem
                    onClick={() => navigate("/staff-expense")}
                  >
                    Staff Expense
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      navigate("/daily-expense-report")
                    }
                  >
                    Daily Expense Report
                  </MenuItem>
                  */}
                </MenuList>
              </Menu>

              {/* ===================================================== */}
              {/* DATA ENTRY */}
              {/* ===================================================== */}

              <Menu>
                <MenuButton {...menuButtonStyle}>
                  <Text fontSize="sm">
                    Data Entry
                  </Text>
                </MenuButton>

                <MenuList zIndex={9999}>
                  {/*
                  <MenuItem
                    onClick={() => navigate("/dashboard")}
                  >
                    Dashboard
                  </MenuItem>
                  */}

                  <MenuItem
                    onClick={() => navigate("/printRegister")}
                  >
                    Business Info
                  </MenuItem>

                  <MenuItem
                    onClick={() => navigate("/table-register")}
                  >
                    Table Registration
                  </MenuItem>

                  <MenuItem
                    onClick={() => navigate("/wine-register")}
                  >
                    Wine Registration
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      navigate("/category-register")
                    }
                  >
                    Wine Category
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      navigate("/foodcategory-register")
                    }
                  >
                    Food Category
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      navigate("/waiter-register")
                    }
                  >
                    Waiter Register
                  </MenuItem>

                  <MenuItem
                    onClick={() => navigate("/ncRegister")}
                  >
                    NC Register
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      navigate("/food-register")
                    }
                  >
                    Item Registration
                  </MenuItem>

                  {/*
                  <MenuItem
                    onClick={() => navigate("/restaurant")}
                  >
                    Restaurant Bill
                  </MenuItem>

                  <MenuItem
                    onClick={() => navigate("/summary")}
                  >
                    Report Summary
                  </MenuItem>
                  */}
                </MenuList>
              </Menu>

              {/* ===================================================== */}
              {/* PAYROLL */}
              {/* ===================================================== */}

              <Menu>
                <MenuButton {...menuButtonStyle}>
                  <Text fontSize="sm">
                    PayRole
                  </Text>
                </MenuButton>

                <MenuList zIndex={9999}>
                  <MenuItem
                    onClick={() => navigate("/userCreate")}
                  >
                    User
                  </MenuItem>

                  <MenuItem
                    onClick={() => navigate("/roleCreate")}
                  >
                    Role
                  </MenuItem>
                </MenuList>
              </Menu>

              {/* ===================================================== */}
              {/* TABLE */}
              {/* ===================================================== */}

              <Menu>
                <MenuButton {...menuButtonStyle}>
                  <Text fontSize="sm">
                    Table
                  </Text>
                </MenuButton>

                <MenuList zIndex={9999}>
                  <MenuItem
                    onClick={() => navigate("/table-status")}
                  >
                    Table Status
                  </MenuItem>
                </MenuList>
              </Menu>

              {/* ===================================================== */}
              {/* KITCHEN */}
              {/* ===================================================== */}

              <Link
                as="b"
                mr={3}
                mt={2}
                p={2}
                onClick={() => navigate("/food")}
                style={getMenuItemStyle("/food")}
                color="white"
                cursor="pointer"
                _hover={{
                  color: "white",
                  textDecoration: "none",
                }}
              >
                Kitchen
              </Link>

              {/* ===================================================== */}
              {/* LIQUOR */}
              {/* ===================================================== */}

              <Link
                as="b"
                mr={3}
                mt={2}
                p={2}
                onClick={() => navigate("/wineData")}
                style={getMenuItemStyle("/wineData")}
                color="white"
                cursor="pointer"
                _hover={{
                  color: "white",
                  textDecoration: "none",
                }}
              >
                Liquor
              </Link>

              {/* ===================================================== */}
              {/* REPORT CARD */}
              {/* ===================================================== */}

              <Menu>
                <MenuButton {...menuButtonStyle}>
                  <Text fontSize="sm">
                    Report Card
                  </Text>
                </MenuButton>

                <MenuList zIndex={9999}>
                  <MenuItem
                    onClick={() => navigate("/kotBill")}
                  >
                    Kot Report
                  </MenuItem>

                  <MenuItem
                    onClick={() => navigate("/quickBill")}
                  >
                    Bill Report
                  </MenuItem>

                  <MenuItem
                    onClick={() => navigate("/dailySales")}
                  >
                    Today Sales Report
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      navigate("/complementarySales")
                    }
                  >
                    Complementary Sales Summary
                  </MenuItem>

                  {/*
                  <MenuItem
                    onClick={() => navigate("/voidBill")}
                  >
                    Void Bill
                  </MenuItem>
                  */}

                  <MenuItem
                    onClick={() => navigate("/waiterBill")}
                  >
                    Waiter Bill
                  </MenuItem>
                </MenuList>
              </Menu>

              {/* ===================================================== */}
              {/* GROCERY MANAGEMENT */}
              {/* ===================================================== */}

              <Menu>
                <MenuButton {...menuButtonStyle}>
                  <Text fontSize="sm">
                    Grocery Management
                  </Text>
                </MenuButton>

                <MenuList zIndex={9999}>
                  <MenuItem
                    onClick={() =>
                      navigate("/supply-register")
                    }
                  >
                    SupplyRegister
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      navigate("/item-register")
                    }
                  >
                    ItemRegister
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      navigate("/store-register")
                    }
                  >
                    StoreRegister
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      navigate("/staff-register")
                    }
                  >
                    StaffRegister
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      navigate("/purchase-register")
                    }
                  >
                    PurchaseRegister
                  </MenuItem>

                  <MenuItem
                    onClick={() => navigate("/store")}
                  >
                    Store
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      navigate("/stock-transfer")
                    }
                  >
                    Stock-Transfer
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      navigate("/purchase-report")
                    }
                  >
                    Purchase-Report
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      navigate("/stock-transfer-report")
                    }
                  >
                    Transfer-Report
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      navigate("/stock-transfer-summary")
                    }
                  >
                    Transfer-Summary
                  </MenuItem>
                </MenuList>
              </Menu>

              {/* ===================================================== */}
              {/* LOGOUT */}
              {/* ===================================================== */}

              <Button
                size="sm"
                mt={2}
                onClick={handleLogout}
                bg="white"
                color="#0F3D2E"
                borderRadius="md"
                _hover={{
                  bg: "white",
                  color: "#0F3D2E",
                }}
              >
                Logout
              </Button>
            </>
          ) : (
            <>
              {/* ===================================================== */}
              {/* LOGIN */}
              {/* ===================================================== */}

              <Button
                size="sm"
                onClick={() => navigate("/login")}
                bg="white"
                color="#0F3D2E"
                _hover={{
                  bg: "white",
                  color: "#0F3D2E",
                }}
              >
                Login
              </Button>

              {/* ===================================================== */}
              {/* SIGNUP */}
              {/* ===================================================== */}

              <Button
                size="sm"
                onClick={() => navigate("/signup")}
                bg="white"
                color="#0F3D2E"
                _hover={{
                  bg: "white",
                  color: "#0F3D2E",
                }}
              >
                Signup
              </Button>
            </>
          )}
        </Stack>
      </Box>

      {/* ========================================================= */}
      {/* MOBILE NAVIGATION */}
      {/* ========================================================= */}

      <Collapse
        in={isOpen}
        animateOpacity
        style={{ width: "100%" }}
      >
        <Box
          display={{
            base: isOpen ? "block" : "none",
            md: "none",
          }}
          width="100%"
          mt={4}
        >
          <Stack
            spacing={4}
            align="center"
            justify="center"
            direction="column"
            pt={4}
          >
            {customerId ? (
              <>
                <Button
                  width="100%"
                  bg="white"
                  color="#0F3D2E"
                  onClick={() => navigate("/off-shop")}
                >
                  🔴 Off Shop
                </Button>

                <Button
                  width="100%"
                  bg="white"
                  color="#0F3D2E"
                  onClick={() => navigate("/all-expense")}
                >
                  Expenses
                </Button>

                <Button
                  width="100%"
                  bg="white"
                  color="#0F3D2E"
                  onClick={() => navigate("/food")}
                >
                  Kitchen
                </Button>

                <Button
                  width="100%"
                  bg="white"
                  color="#0F3D2E"
                  onClick={() => navigate("/wineData")}
                >
                  Liquor
                </Button>

                <Button
                  width="100%"
                  bg="white"
                  color="#0F3D2E"
                  onClick={() => navigate("/table-status")}
                >
                  Table
                </Button>

                <Button
                  width="100%"
                  bg="white"
                  color="#0F3D2E"
                  onClick={() => navigate("/dailySales")}
                >
                  Sales Report
                </Button>

                <Button
                  width="100%"
                  bg="white"
                  color="#0F3D2E"
                  onClick={handleLogout}
                >
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Button
                  width="100%"
                  bg="white"
                  color="#0F3D2E"
                  onClick={() => navigate("/login")}
                >
                  Login
                </Button>

                <Button
                  width="100%"
                  bg="white"
                  color="#0F3D2E"
                  onClick={() => navigate("/signup")}
                >
                  Signup
                </Button>
              </>
            )}
          </Stack>
        </Box>
      </Collapse>
    </Flex>
  );
};

export default Navbar;